export interface UserApiUsage {
  id: string;
  public_id: string;
  display_name: string;
  email: string;
  processed_emails: number;
  ai_calls: number;
  input_tokens: number;
  output_tokens: number;
  cached_tokens: number;
  cost_micros_usd: number;
}
export interface ApiUsageReport {
  month: string;
  users: UserApiUsage[];
}

export function currentUsageMonth(now = new Date()): string {
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Tokyo', year: 'numeric', month: '2-digit' }).format(now).slice(0, 7);
}

export function validUsageMonth(value: string): boolean {
  return /^\d{4}-(0[1-9]|1[0-2])$/.test(value);
}

export function usageCsv(report: ApiUsageReport): string {
  const cell = (value: string | number) => {
    const text = String(value);
    // Spreadsheet applications must not execute names/email addresses as formulas.
    const safe = /^[=+\-@\t\r\n]/.test(text) ? `'${text}` : text;
    return `"${safe.replaceAll('"', '""')}"`;
  };
  const rows = [
    ['対象月（日本時間）', '利用者ID', '名前', 'メール', '処理メール数', 'AI呼び出し回数', '入力tokens（キャッシュ含む）', '出力tokens（思考含む）', 'キャッシュtokens（入力の内数）', 'AI概算料金（USD）'],
    ...report.users.map((u) => [report.month, u.public_id, u.display_name, u.email, u.processed_emails, u.ai_calls, u.input_tokens, u.output_tokens, u.cached_tokens, (u.cost_micros_usd / 1_000_000).toFixed(6)]),
  ];
  return '\uFEFF' + rows.map((row) => row.map(cell).join(',')).join('\r\n') + '\r\n';
}
